<template lang="pug">
	ul.navbar-nav.account-button(v-if="User.User")
		li.nav-item.px-3
			.account
				.user-photo(:style="{ backgroundImage: 'url(' + User.User.photo || 'img/login/default-user-icon.png' + ')' }" v-pseudo-modal-show="'account-dropdown'")
		div.dropdown-menu(v-pseudo-modal="'account-dropdown'")
			.administration(v-if="User.isCurentUserAdmin && User.User.haveAccess")
				b-dropdown-header(tag="div" class="text-center")
					strong Administration
				b-dropdown-item(@click="updateUsersCache()")
					span Update users cache
			.account
				b-dropdown-header(tag="div" class="text-center")
					strong Account
				b-dropdown-item(@click="User.logout()")
					span Logout
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User';
	import { Template } 		from './../../services/Template';
	import { Asset } 			from './../../services/Asset';
	import { Monitoring } 		from './../../services/Monitoring'

	export default {
		name: "AccountButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Compression Cache Size Changed"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				}
			}
		},
		data() {

			this.User = User;
			this.Template = Template;
			this.Monitoring = Monitoring;

			return {
				showed: true,
				compressionCacheSize: null
			}

		},
		methods: {
			collectData() {

				this.compressionCacheSize = Asset.CompressionCacheSize || 0;

			},

			updateUsersCache() {

				User.updateUsersCache();

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},

		}
	}
</script>

<style lang="sass">

	ul.account-button
		list-style: none
		position: relative

		a.nav-link.download
			font-size: 25px
			line-height: 23px

		.dropdown-menu
			position: absolute
			left: -140px
			top: 30px
			display: block
			z-index: 10000
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			line-height: 1

			li:not(:first-child)
				.dropdown-item
					border-top: 1px solid rgba(0, 0, 0, 0.2)

			li:nth-child(2)
				.dropdown-item
					border-top: none

			li.selected
				.dropdown-item
					background-color: #20a8d8

			.icon
				margin-left: 6px

		.nav-link,
		.nav-link:focus
			color: #c8ced3

		.nav-link:hover
			color: #fff

		.user-photo
			background: center / auto 100% no-repeat
			width: 35px
			height: 35px
			border-radius: 35px
			cursor: pointer

</style>

